<header class="grid center-item">
  <div class="grid__col-sm-12 center-item guts-p-t-4 guts-p-b-3">
    <div class="l_flexbar m-l_flexbar-col">
      <div class="m-center-text l_flex-grow full-width">
        <div ng-class="{ l_flexbar: !isMobile }">
          <div class="l_flex-grow">
            <h1 class="h1">{{ i18n.User_PageTitle }}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
